"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8793],{

/***/ 301831:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$Z": function() { return /* binding */ Card7; },
/* harmony export */   "CQ": function() { return /* binding */ Card11; },
/* harmony export */   "GL": function() { return /* binding */ Card3; },
/* harmony export */   "P": function() { return /* binding */ Card9; },
/* harmony export */   "Pe": function() { return /* binding */ Card13; },
/* harmony export */   "_7": function() { return /* binding */ Card12; },
/* harmony export */   "st": function() { return /* binding */ Card1; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(186812);
/* harmony import */ var _utils_getCustomCtaText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(336623);
/* harmony import */ var _utils_returnSpecificImageUrl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(828631);
/* harmony import */ var _redux_ssrStore__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(326706);






var Card1 = function(param) {
    var widgetConfig = param.widgetConfig, category = param.category, key = param.key, onClick = param.onClick, horizontal = param.horizontal;
    var ref;
    // const { deviceWidth } = IS_SERVER ? { deviceWidth: 0 } : getDeviceInfo();
    // const style = {
    //   height: widgetConfig.card_cta_visibility
    //     ? deviceWidth < 900
    //       ? '400px'
    //       : widgetConfig?.image_dimension?.height
    //     : widgetConfig?.image_dimension?.height,
    //   minWidth: widgetConfig.card_cta_visibility
    //     ? deviceWidth < 900
    //       ? '300px'
    //       : '750px'
    //     : '300px',
    // };
    var theme = (0,_redux_ssrStore__WEBPACK_IMPORTED_MODULE_5__/* .useSSRSelector */ .kF)(function(state) {
        return state.storeReducer.store;
    }).theme;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("article", {
        className: "category-card-1",
        // style={style}
        onClick: function() {
            return onClick(category);
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: {
                    backgroundImage: "url(".concat((0,_utils_returnSpecificImageUrl__WEBPACK_IMPORTED_MODULE_4__/* .returnSpecificImageUrl */ .B)({
                        theme: theme,
                        item: category
                    }), ")"),
                    paddingTop: "".concat(widgetConfig === null || widgetConfig === void 0 ? void 0 : widgetConfig.aspect_ratio, "%"),
                    backgroundSize: "cover"
                },
                className: "image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "category-name tc",
                children: category.name ? category.name : "Available Items"
            }),
            (widgetConfig === null || widgetConfig === void 0 ? void 0 : widgetConfig.card_cta_visibility) && (!horizontal ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                className: "category-btn db-ns dn",
                children: theme === null || theme === void 0 ? void 0 : (ref = theme.cta_config) === null || ref === void 0 ? void 0 : ref.banner_cta
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                className: "horizontal-category-btn db-ns dn",
                children: (0,_utils_getCustomCtaText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("widget_cta")
            }))
        ]
    }, key);
};
var Card3 = function(param) {
    var widgetConfig = param.widgetConfig, category = param.category, key = param.key, onClick = param.onClick;
    var theme = (0,_redux_ssrStore__WEBPACK_IMPORTED_MODULE_5__/* .useSSRSelector */ .kF)(function(state) {
        return state.storeReducer.store;
    }).theme;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("article", {
        className: "category-card-3",
        // style={{ height: widgetConfig.image_dimension.height }}
        style: {
            height: "auto"
        },
        onClick: function() {
            return onClick(category);
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: (0,_utils_returnSpecificImageUrl__WEBPACK_IMPORTED_MODULE_4__/* .returnSpecificImageUrl */ .B)({
                    theme: theme,
                    item: category
                })
            }),
            (widgetConfig === null || widgetConfig === void 0 ? void 0 : widgetConfig.card_cta_visibility) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                className: "category-btn",
                children: category.name ? category.name : "Available Items"
            })
        ]
    }, key);
};
var Card7 = function(param) {
    var widgetConfig = param.widgetConfig, category = param.category, cardIndx = param.cardIndx, onClick = param.onClick, skewDirection = param.skewDirection;
    var theme = (0,_redux_ssrStore__WEBPACK_IMPORTED_MODULE_5__/* .useSSRSelector */ .kF)(function(state) {
        return state.storeReducer.store;
    }).theme;
    var skewAngle = _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_2__/* .deviceWidth */ .o > 990 ? 15 : 5;
    var skew = {
        right: "skew(".concat(skewAngle, "deg)"),
        left: "skew(-".concat(skewAngle, "deg)")
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("article", {
        className: "category-card-7",
        style: {
            // height: widgetConfig.image_dimension.height,
            transform: skew[skewDirection]
        },
        onClick: function() {
            return onClick(category);
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: {
                    backgroundImage: "url(".concat((0,_utils_returnSpecificImageUrl__WEBPACK_IMPORTED_MODULE_4__/* .returnSpecificImageUrl */ .B)({
                        theme: theme,
                        item: category
                    }), ")"),
                    paddingTop: "".concat(widgetConfig === null || widgetConfig === void 0 ? void 0 : widgetConfig.aspect_ratio, "%"),
                    backgroundSize: "cover"
                }
            }),
            (widgetConfig === null || widgetConfig === void 0 ? void 0 : widgetConfig.card_cta_visibility) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                className: "category-btn ",
                children: category.name ? category.name : "Available Items"
            })
        ]
    }, cardIndx);
};
var Card9 = function(param) {
    var widgetConfig = param.widgetConfig, category = param.category, key = param.key, onClick = param.onClick, horizontal = param.horizontal;
    var theme = (0,_redux_ssrStore__WEBPACK_IMPORTED_MODULE_5__/* .useSSRSelector */ .kF)(function(state) {
        return state.storeReducer.store;
    }).theme;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("article", {
        className: "category-card-9",
        onClick: function() {
            return onClick(category);
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: {
                    backgroundImage: "url(".concat((0,_utils_returnSpecificImageUrl__WEBPACK_IMPORTED_MODULE_4__/* .returnSpecificImageUrl */ .B)({
                        theme: theme,
                        item: category
                    }), ")"),
                    paddingTop: "".concat(widgetConfig === null || widgetConfig === void 0 ? void 0 : widgetConfig.aspect_ratio, "%")
                },
                className: "image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "category-name tc",
                children: category.name ? category.name : "Available Items"
            }),
            (widgetConfig === null || widgetConfig === void 0 ? void 0 : widgetConfig.card_cta_visibility) && (!horizontal ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                className: "category-btn db-ns dn",
                children: "Explore"
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                className: "horizontal-category-btn db-ns dn",
                children: "Explore"
            }))
        ]
    }, key);
};
var Card11 = function(param) {
    var widgetConfig = param.widgetConfig, category = param.category, key = param.key, onClick = param.onClick, horizontal = param.horizontal;
    var theme = (0,_redux_ssrStore__WEBPACK_IMPORTED_MODULE_5__/* .useSSRSelector */ .kF)(function(state) {
        return state.storeReducer.store;
    }).theme;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "category-card-11 ".concat(horizontal ? "horizontal-card" : ""),
        onClick: function() {
            return onClick(category);
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: {
                    backgroundImage: "url(".concat((0,_utils_returnSpecificImageUrl__WEBPACK_IMPORTED_MODULE_4__/* .returnSpecificImageUrl */ .B)({
                        theme: theme,
                        item: category
                    }), ")"),
                    paddingTop: "".concat(widgetConfig === null || widgetConfig === void 0 ? void 0 : widgetConfig.aspect_ratio, "%"),
                    backgroundPosition: "center",
                    backgroundSize: "contain"
                },
                className: "image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "category-name tc mv0",
                children: category.name ? category.name : "Available Items"
            })
        ]
    }, key);
};
var Card12 = function(param) {
    var widgetConfig = param.widgetConfig, category = param.category, key = param.key, onClick = param.onClick, horizontal = param.horizontal;
    var theme = (0,_redux_ssrStore__WEBPACK_IMPORTED_MODULE_5__/* .useSSRSelector */ .kF)(function(state) {
        return state.storeReducer.store;
    }).theme;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "category-card-12 ".concat(horizontal ? "horizontal-card" : ""),
        onClick: function() {
            return onClick(category);
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: {
                    backgroundImage: "url(".concat((0,_utils_returnSpecificImageUrl__WEBPACK_IMPORTED_MODULE_4__/* .returnSpecificImageUrl */ .B)({
                        theme: theme,
                        item: category
                    }), ")"),
                    paddingTop: "".concat(widgetConfig === null || widgetConfig === void 0 ? void 0 : widgetConfig.aspect_ratio, "%"),
                    backgroundPosition: "center",
                    backgroundSize: "contain"
                },
                className: "image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "category-name tc mv0",
                children: category.name ? category.name : "Available Items"
            })
        ]
    }, key);
};
var Card13 = function(param) {
    var widgetConfig = param.widgetConfig, category = param.category, key = param.key, onClick = param.onClick, horizontal = param.horizontal;
    var theme = (0,_redux_ssrStore__WEBPACK_IMPORTED_MODULE_5__/* .useSSRSelector */ .kF)(function(state) {
        return state.storeReducer.store;
    }).theme;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "category-card-13 ".concat(horizontal ? "horizontal-card" : ""),
        onClick: function() {
            return onClick(category);
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "relative w-100",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    style: {
                        backgroundImage: "url(".concat((0,_utils_returnSpecificImageUrl__WEBPACK_IMPORTED_MODULE_4__/* .returnSpecificImageUrl */ .B)({
                            theme: theme,
                            item: category
                        }), ")"),
                        paddingTop: "".concat(widgetConfig === null || widgetConfig === void 0 ? void 0 : widgetConfig.aspect_ratio, "%")
                    },
                    className: "image"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "category-name tc mv0 z-5",
                    style: {
                        paddingTop: "calc(".concat(widgetConfig === null || widgetConfig === void 0 ? void 0 : widgetConfig.aspect_ratio, "% - 29px)")
                    },
                    children: category.name ? category.name : "Available Items"
                })
            ]
        })
    }, key);
};


/***/ }),

/***/ 698793:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(811163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _cards__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(301831);
/* harmony import */ var _utils_isPLPRequiredSystem__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(586423);
/* harmony import */ var _utils_routes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(540190);
/* harmony import */ var _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(186812);
/* harmony import */ var _redux_ssrStore__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(326706);








var CategoryWidget = function(props) {
    var _showSeeMoreBtn = props.showSeeMoreBtn, showSeeMoreBtn = _showSeeMoreBtn === void 0 ? true : _showSeeMoreBtn;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), widgetConfig = ref[0], setWidgetConfig = ref[1];
    /**
   * calculate the max number of items that are to be
   * rendered initially when page initialises
   * result depends on deviceWidth
   * Sample config structure
   * {
    "animation": "pop",
    "aspect_ratio": 100,
    "card_cta_visibility": false,
    "desktop": {
        "grid": {
            "cols": 2,
            "rows": 2
        },
        "spacing": 24
    },
    "heading": "Categories",
    "mobile": {
        "grid": {
            "cols": 1,
            "rows": 2
        },
        "spacing": 24
    },
    "spacing": 24
    }
   * @return {number} number of items
   */ var getMaxItemsToBeRenderedInitially = function() {
        var ref;
        var gridConfig = {};
        if (_utils_deviceWidth__WEBPACK_IMPORTED_MODULE_5__/* .deviceWidth */ .o < 766) {
            var ref1;
            gridConfig = (ref1 = props.config) === null || ref1 === void 0 ? void 0 : ref1.mobile;
        } else {
            var ref2;
            gridConfig = (ref2 = props.config) === null || ref2 === void 0 ? void 0 : ref2.desktop;
        }
        if ((gridConfig === null || gridConfig === void 0 ? void 0 : (ref = gridConfig.grid) === null || ref === void 0 ? void 0 : ref.cols) === 1) {
            return 4;
        } else {
            var ref3;
            return (gridConfig === null || gridConfig === void 0 ? void 0 : (ref3 = gridConfig.grid) === null || ref3 === void 0 ? void 0 : ref3.cols) * 2;
        }
    };
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(getMaxItemsToBeRenderedInitially()), lastCategoryVisibleIndex = ref1[0], setLastCategoryVisibleIndex = ref1[1];
    var ref2 = (0,_redux_ssrStore__WEBPACK_IMPORTED_MODULE_6__/* .useSSRSelector */ .kF)(function(state) {
        return {
            catalogCategories: state.catalogReducer.categories,
            storeData: state.storeReducer.store
        };
    }), catalogCategories = ref2.catalogCategories, storeData = ref2.storeData;
    var toggleCategoryExpansion = function() {
        if ((catalogCategories === null || catalogCategories === void 0 ? void 0 : catalogCategories.length) > lastCategoryVisibleIndex) {
            setLastCategoryVisibleIndex(catalogCategories.length || 0);
        } else {
            setLastCategoryVisibleIndex(getMaxItemsToBeRenderedInitially());
        }
    };
    /**
   * showSeeMoreBtn comes in as prop and is used to conditionally render
   * the max amount of category items. In /categories page, there is no max limit on
   * the items that can be rendered at a time.
   * showSeeMoreBtn is false for /categories page
   */ (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (props.config) {
            setWidgetConfig(props.config);
            setLastCategoryVisibleIndex(showSeeMoreBtn ? getMaxItemsToBeRenderedInitially() : catalogCategories === null || catalogCategories === void 0 ? void 0 : catalogCategories.length);
        }
    }, [
        props.config,
        catalogCategories
    ]);
    /**
   * conditionally render show more/less btn.
   * for button to render num of categories should be more than
   * max items to be rendered before button toggle
   * @return {boolean} boolean
   */ var renderShowBtn = function() {
        return showSeeMoreBtn && (catalogCategories === null || catalogCategories === void 0 ? void 0 : catalogCategories.length) > getMaxItemsToBeRenderedInitially();
    };
    var onCategoryItemClick = function(category) {
        var ref;
        if ((0,_utils_isPLPRequiredSystem__WEBPACK_IMPORTED_MODULE_7__/* .isPLPRequiredSystem */ .q)(storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : ref.theme_class)) {
            var ref1;
            router.push((0,_utils_routes__WEBPACK_IMPORTED_MODULE_4__.getRoute)("".concat(_utils_routes__WEBPACK_IMPORTED_MODULE_4__.PATH.SHOP, "?cid=").concat(category.id), storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.store_info) === null || ref1 === void 0 ? void 0 : ref1.domain), undefined, {
                shallow: true
            });
        } else {
            var ref2;
            router.push((0,_utils_routes__WEBPACK_IMPORTED_MODULE_4__.getRoute)("".concat(_utils_routes__WEBPACK_IMPORTED_MODULE_4__.PATH.PRODUCT, "?cid=").concat(category.id), storeData === null || storeData === void 0 ? void 0 : (ref2 = storeData.store_info) === null || ref2 === void 0 ? void 0 : ref2.domain), undefined, {
                shallow: true
            });
        }
    };
    var _renderCategoryCard = function(category, idx, cardNumber) {
        switch(cardNumber){
            case 1:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cards__WEBPACK_IMPORTED_MODULE_3__/* .Card1 */ .st, {
                    category: category,
                    widgetConfig: widgetConfig,
                    onClick: onCategoryItemClick
                }, idx);
            case 3:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cards__WEBPACK_IMPORTED_MODULE_3__/* .Card3 */ .GL, {
                    category: category,
                    widgetConfig: widgetConfig,
                    onClick: onCategoryItemClick
                }, idx);
            case 7:
                var ref, ref1;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cards__WEBPACK_IMPORTED_MODULE_3__/* .Card7 */ .$Z, {
                    category: category,
                    cardIndx: idx,
                    widgetConfig: widgetConfig,
                    onClick: onCategoryItemClick,
                    skewDirection: Math.ceil((idx + 1) / (_utils_deviceWidth__WEBPACK_IMPORTED_MODULE_5__/* .deviceWidth */ .o > 990 ? (widgetConfig === null || widgetConfig === void 0 ? void 0 : (ref = widgetConfig.desktop) === null || ref === void 0 ? void 0 : (ref1 = ref.grid) === null || ref1 === void 0 ? void 0 : ref1.cols) || 3 : 1)) % 2 !== 0 ? "left" : "right"
                });
            case 9:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cards__WEBPACK_IMPORTED_MODULE_3__/* .Card9 */ .P, {
                    category: category,
                    widgetConfig: widgetConfig,
                    onClick: onCategoryItemClick
                }, idx);
            default:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cards__WEBPACK_IMPORTED_MODULE_3__/* .Card1 */ .st, {
                    category: category,
                    widgetConfig: widgetConfig,
                    onClick: onCategoryItemClick
                }, idx);
        }
    };
    /**
   * returns the number of columns columns from
   * props.config based on the device width
   * @return {number} no of columns
   */ var returnGridTemplateColumns = function() {
        var ref, ref1, ref2, ref3;
        return _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_5__/* .deviceWidth */ .o < 766 ? (widgetConfig === null || widgetConfig === void 0 ? void 0 : (ref = widgetConfig.mobile) === null || ref === void 0 ? void 0 : (ref1 = ref.grid) === null || ref1 === void 0 ? void 0 : ref1.cols) || 1 : (widgetConfig === null || widgetConfig === void 0 ? void 0 : (ref2 = widgetConfig.desktop) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.grid) === null || ref3 === void 0 ? void 0 : ref3.cols) || 3;
    };
    /**
   * returns the grid gap value based on
   * deviceWidth
   * @return {number} grid gap value
   */ var returnGridSpacing = function() {
        var ref, ref1;
        return _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_5__/* .deviceWidth */ .o < 766 ? (widgetConfig === null || widgetConfig === void 0 ? void 0 : (ref = widgetConfig.mobile) === null || ref === void 0 ? void 0 : ref.spacing) || 20 : (widgetConfig === null || widgetConfig === void 0 ? void 0 : (ref1 = widgetConfig.desktop) === null || ref1 === void 0 ? void 0 : ref1.spacing) || 20;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "vertical-categoryWidget flex justify-center items-center",
        children: widgetConfig && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "vertical-categoryWidget__container",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "vertical-categoryWidget__title tc fw6",
                    children: widgetConfig === null || widgetConfig === void 0 ? void 0 : widgetConfig.heading
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                    className: "vertical-categoryWidget__box",
                    style: {
                        gridTemplateColumns: "repeat(".concat(returnGridTemplateColumns(), ", 1fr)"),
                        gridGap: "".concat(returnGridSpacing(), "px")
                    },
                    children: catalogCategories === null || catalogCategories === void 0 ? void 0 : catalogCategories.slice(0, lastCategoryVisibleIndex).map(function(category, index) {
                        return _renderCategoryCard(category, index, props.cardType);
                    })
                }),
                renderShowBtn() && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                    className: "see-more-btn flex justify-center items-center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        onClick: toggleCategoryExpansion,
                        className: "expandable-btn",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                            className: "w-100 tc",
                            children: [
                                "See",
                                " ",
                                (catalogCategories === null || catalogCategories === void 0 ? void 0 : catalogCategories.length) > lastCategoryVisibleIndex ? "More" : "Less"
                            ]
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CategoryWidget);


/***/ }),

/***/ 940619:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hp": function() { return /* binding */ imgSizeEnums; },
/* harmony export */   "N7": function() { return /* binding */ getMaxImgSizeForComponent; },
/* harmony export */   "VW": function() { return /* binding */ getSrcSetFromCompressedImages; },
/* harmony export */   "Xx": function() { return /* binding */ componentTypeEnums; },
/* harmony export */   "vb": function() { return /* binding */ getImageUrlFromCompressedImages; }
/* harmony export */ });
var componentTypeEnums = {
    CARD: 1,
    ITEM_THUMBNAIL: 2
};
var imgSizeEnums = {
    LOW: 1,
    MID: 2,
    HIGH: 3
};
// the srcset is creating a few problems where device pixel ratio is high (loading a lower resolution image)
// consider using getImageUrlFromCompressedImages for any such cases
function getSrcSetFromCompressedImages() {
    var compressedImages = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, mainImage = arguments.length > 1 ? arguments[1] : void 0, extraFields = arguments.length > 2 ? arguments[2] : void 0;
    var parsedCompressedImages = parseCompressedImageObj(compressedImages || {});
    return prepareSrcSet(parsedCompressedImages, mainImage, (extraFields === null || extraFields === void 0 ? void 0 : extraFields.maxImgSize) || imgSizeEnums.HIGH, (extraFields === null || extraFields === void 0 ? void 0 : extraFields.minImgSize) || imgSizeEnums.LOW);
}
function getImageUrlFromCompressedImages() {
    var compressedImages = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, mainImage = arguments.length > 1 ? arguments[1] : void 0, extraFields = arguments.length > 2 ? arguments[2] : void 0;
    var parsedCompressedImages = parseCompressedImageObj(compressedImages || {});
    var screenWidth =  false ? 0 : window.innerWidth;
    var maxImgSize = (extraFields === null || extraFields === void 0 ? void 0 : extraFields.maxImgSize) || imgSizeEnums.HIGH;
    var urlToReturn = mainImage;
    if (parsedCompressedImages[imgSizeEnums.LOW] && (screenWidth <= 320 || maxImgSize === imgSizeEnums.LOW)) {
        urlToReturn = parsedCompressedImages[imgSizeEnums.LOW];
    } else if (parsedCompressedImages[imgSizeEnums.MID] && (screenWidth > 320 && screenWidth < 768 || maxImgSize === imgSizeEnums.MID)) {
        urlToReturn = parsedCompressedImages[imgSizeEnums.MID];
    } else if (parsedCompressedImages[imgSizeEnums.HIGH]) {
        urlToReturn = parsedCompressedImages[imgSizeEnums.HIGH];
    }
    return urlToReturn;
}
function prepareSrcSet() {
    var imgObj = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, mainImage = arguments.length > 1 ? arguments[1] : void 0, maxImgSize = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : imgSizeEnums.HIGH, minImgSize = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : imgSizeEnums.LOW;
    var resString = "";
    var dpr =  false ? 0 : window.devicePixelRatio;
    if (minImgSize <= imgSizeEnums.LOW && maxImgSize >= imgSizeEnums.LOW && imgObj[imgSizeEnums.LOW]) {
        resString += "".concat(imgObj[imgSizeEnums.LOW], " ").concat(320 * dpr, "w, ");
    }
    if (minImgSize <= imgSizeEnums.MID && maxImgSize >= imgSizeEnums.MID && imgObj[imgSizeEnums.MID]) {
        resString += "".concat(imgObj[imgSizeEnums.MID], " ").concat(480 * dpr, "w, ");
    }
    if (minImgSize <= imgSizeEnums.HIGH && maxImgSize >= imgSizeEnums.HIGH && imgObj[imgSizeEnums.HIGH]) {
        resString += "".concat(imgObj[imgSizeEnums.HIGH], " ").concat(768 * dpr, "w, ");
    }
    if (!maxImgSize || !resString) {
        resString += "".concat(mainImage);
    }
    return resString;
}
// returns Object with image urls corresponding to low medium and high which is Represented by 1,2,3
function parseCompressedImageObj() {
    var compressedImages = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var res = {};
    var keys = Object.keys(compressedImages) // keys are strings where numbers are separated by *. Eg. "200*200"
    ;
    // sorting keys (eg. key=200*200) to handle the case when we get jumbled order of image sizes.
    keys.sort(function(a, b) {
        var first = parseInt(a.split("*")[0]);
        var second = parseInt(b.split("*")[0]);
        return first - second;
    });
    if (keys.length >= 1) {
        res[imgSizeEnums.LOW] = compressedImages[keys[0]];
    }
    if (keys.length >= 2) {
        res[imgSizeEnums.MID] = compressedImages[keys[1]];
    }
    if (keys.length >= 3) {
        res[imgSizeEnums.HIGH] = compressedImages[keys[2]];
    }
    return res;
}
function getMaxImgSizeForComponent(componentType) {
    if (componentType === componentTypeEnums.CARD) {
        return imgSizeEnums.MID;
    } else if (componentType === componentTypeEnums.ITEM_THUMBNAIL) {
        return imgSizeEnums.LOW;
    }
    return imgSizeEnums.MID;
}


/***/ }),

/***/ 828631:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ returnSpecificImageUrl; }
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(913886);
/* harmony import */ var _compressedImagesHelpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(940619);


/*
 returns either image_url or thumbnail_url,
 depending on the configuration of theme config 'product_image_quality_flag'
 */ function returnSpecificImageUrl(param) {
    var theme = param.theme, item = param.item;
    if (!theme || !(theme === null || theme === void 0 ? void 0 : theme.product_image_quality_flag)) return (0,_compressedImagesHelpers__WEBPACK_IMPORTED_MODULE_1__/* .getImageUrlFromCompressedImages */ .vb)(item === null || item === void 0 ? void 0 : item.compressed_images, item === null || item === void 0 ? void 0 : item.image_url, {
        maxImgSize: (0,_compressedImagesHelpers__WEBPACK_IMPORTED_MODULE_1__/* .getMaxImgSizeForComponent */ .N7)(_compressedImagesHelpers__WEBPACK_IMPORTED_MODULE_1__/* .componentTypeEnums.CARD */ .Xx.CARD)
    });
    return (theme === null || theme === void 0 ? void 0 : theme.product_image_quality_flag) === _constants__WEBPACK_IMPORTED_MODULE_0__/* .IMAGE_CONFIG_CONSTANT.THUMBNAIL_IMAGE */ .of.THUMBNAIL_IMAGE ? (item === null || item === void 0 ? void 0 : item.thumbnail_url) || (item === null || item === void 0 ? void 0 : item.image_url) : (0,_compressedImagesHelpers__WEBPACK_IMPORTED_MODULE_1__/* .getImageUrlFromCompressedImages */ .vb)(item === null || item === void 0 ? void 0 : item.compressed_images, item === null || item === void 0 ? void 0 : item.image_url, {
        maxImgSize: (0,_compressedImagesHelpers__WEBPACK_IMPORTED_MODULE_1__/* .getMaxImgSizeForComponent */ .N7)(_compressedImagesHelpers__WEBPACK_IMPORTED_MODULE_1__/* .componentTypeEnums.CARD */ .Xx.CARD)
    });
}


/***/ })

}]);